import { useState as p, useEffect as m } from "react";
import { gray as s, purple as u, base as f } from "../foundations/color/index.js";
const w = (e) => ({
  or: e.formatMessage({
    id: "4wpUNc",
    defaultMessage: [{
      type: 0,
      value: "Or"
    }]
  }),
  menu: {
    files: e.formatMessage({
      id: "AjhJXS",
      defaultMessage: [{
        type: 0,
        value: "My Files"
      }]
    })
  },
  local: {
    browse: e.formatMessage({
      id: "AetNAD",
      defaultMessage: [{
        type: 0,
        value: "Browse"
      }]
    }),
    dd_title_single: e.formatMessage({
      id: "GyVL+y",
      defaultMessage: [{
        type: 0,
        value: "Drag and Drop an asset here"
      }]
    }),
    dd_title_multi: e.formatMessage({
      id: "3ZwCrL",
      defaultMessage: [{
        type: 0,
        value: "Drag and Drop assets here"
      }]
    }),
    drop_title_single: e.formatMessage({
      id: "KrJHKp",
      defaultMessage: [{
        type: 0,
        value: "Drop a file to upload"
      }]
    }),
    drop_title_multiple: e.formatMessage({
      id: "9aD6GO",
      defaultMessage: [{
        type: 0,
        value: "Drop files to upload"
      }]
    })
  },
  queue: {
    title: e.formatMessage({
      id: "J1heb1",
      defaultMessage: [{
        type: 0,
        value: "Upload Queue"
      }]
    }),
    title_uploading_with_counter: e.formatMessage({
      id: "1O6LIm",
      defaultMessage: [{
        type: 0,
        value: "Uploading "
      }, {
        type: 1,
        value: "num"
      }, {
        type: 0,
        value: " Assets"
      }]
    }, {
      num: "{{num}}"
    }),
    title_uploading: e.formatMessage({
      id: "rWfLe+",
      defaultMessage: [{
        type: 0,
        value: "Uploading Assets"
      }]
    }),
    mini_title: e.formatMessage({
      id: "LwdDVa",
      defaultMessage: [{
        type: 0,
        value: "Uploaded"
      }]
    }),
    mini_title_uploading: e.formatMessage({
      id: "hsYvDX",
      defaultMessage: [{
        type: 0,
        value: "Uploading"
      }]
    }),
    show_completed: e.formatMessage({
      id: "l9kDZq",
      defaultMessage: [{
        type: 0,
        value: "Show completed"
      }]
    }),
    retry_failed: e.formatMessage({
      id: "IeZnKQ",
      defaultMessage: [{
        type: 0,
        value: "Retry failed"
      }]
    }),
    abort_all: e.formatMessage({
      id: "jnKBW0",
      defaultMessage: [{
        type: 0,
        value: "Abort all"
      }]
    }),
    upload_more: e.formatMessage({
      id: "w6J38y",
      defaultMessage: [{
        type: 0,
        value: "Upload more"
      }]
    }),
    done: e.formatMessage({
      id: "JXdbo8",
      defaultMessage: [{
        type: 0,
        value: "Done"
      }]
    }),
    mini_upload_count: e.formatMessage({
      id: "99oTOg",
      defaultMessage: [{
        type: 1,
        value: "num"
      }, {
        type: 0,
        value: " uploaded"
      }]
    }, {
      num: "{{num}}"
    }),
    mini_failed: e.formatMessage({
      id: "7gqDGc",
      defaultMessage: [{
        type: 1,
        value: "num"
      }, {
        type: 0,
        value: " failed"
      }]
    }, {
      num: "{{num}}"
    }),
    statuses: {
      uploading: e.formatMessage({
        id: "JEsxDw",
        defaultMessage: [{
          type: 0,
          value: "Uploading..."
        }]
      }),
      error: e.formatMessage({
        id: "KN7zKn",
        defaultMessage: [{
          type: 0,
          value: "Error"
        }]
      }),
      uploaded: e.formatMessage({
        id: "JXdbo8",
        defaultMessage: [{
          type: 0,
          value: "Done"
        }]
      }),
      aborted: e.formatMessage({
        id: "t4hwZA",
        defaultMessage: [{
          type: 0,
          value: "Aborted"
        }]
      })
    }
  },
  uploader: {
    errors: {
      file_too_large: e.formatMessage({
        id: "cGO4U0",
        defaultMessage: [{
          type: 0,
          value: "File size ("
        }, {
          type: 1,
          value: "size"
        }, {
          type: 0,
          value: ") exceeds maximum allowed ("
        }, {
          type: 1,
          value: "allowed"
        }, {
          type: 0,
          value: ")"
        }]
      }, {
        size: "{{size}}",
        allowed: "{{allowed}}"
      }),
      max_dimensions_validation: e.formatMessage({
        id: "DXCo0j",
        defaultMessage: [{
          type: 0,
          value: "Image dimensions ("
        }, {
          type: 1,
          value: "width"
        }, {
          type: 0,
          value: "X"
        }, {
          type: 1,
          value: "height"
        }, {
          type: 0,
          value: ") are bigger than the maximum allowed: ("
        }, {
          type: 1,
          value: "maxWidth"
        }, {
          type: 0,
          value: "X"
        }, {
          type: 1,
          value: "maxHeight"
        }, {
          type: 0,
          value: ")"
        }]
      }, {
        width: "{{width}}",
        height: "{{height}}",
        maxWidth: "{{maxWidth}}",
        maxHeight: "{{maxHeight}}"
      }),
      min_dimensions_validation: e.formatMessage({
        id: "CkbYXz",
        defaultMessage: [{
          type: 0,
          value: "Image dimensions ("
        }, {
          type: 1,
          value: "width"
        }, {
          type: 0,
          value: "X"
        }, {
          type: 1,
          value: "height"
        }, {
          type: 0,
          value: ") are smaller than the minimum required: ("
        }, {
          type: 1,
          value: "minWidth"
        }, {
          type: 0,
          value: "X"
        }, {
          type: 1,
          value: "minHeight"
        }, {
          type: 0,
          value: ")"
        }]
      }, {
        width: "{{width}}",
        height: "{{height}}",
        minWidth: "{{minWidth}}",
        minHeight: "{{minHeight}}"
      }),
      unavailable: e.formatMessage({
        id: "ef99Fb",
        defaultMessage: [{
          type: 0,
          value: "NA"
        }]
      }),
      max_number_of_files: e.formatMessage({
        id: "WrC3fL",
        defaultMessage: [{
          type: 0,
          value: "Maximum number of files exceeded"
        }]
      }),
      allowed_formats: e.formatMessage({
        id: "zKcR07",
        defaultMessage: [{
          type: 0,
          value: "File format not allowed"
        }]
      }),
      max_file_size: e.formatMessage({
        id: "uFwMw7",
        defaultMessage: [{
          type: 0,
          value: "File is too large"
        }]
      }),
      min_file_size: e.formatMessage({
        id: "fFuV7a",
        defaultMessage: [{
          type: 0,
          value: "File is too small"
        }]
      })
    },
    close_mid_upload: e.formatMessage({
      id: "ILOlvJ",
      defaultMessage: [{
        type: 0,
        value: "There are running uploads. Click OK to abort."
      }]
    })
  },
  crop: {
    title: e.formatMessage({
      id: "RNRpjD",
      defaultMessage: [{
        type: 0,
        value: "Crop"
      }]
    }),
    crop_btn: e.formatMessage({
      id: "RNRpjD",
      defaultMessage: [{
        type: 0,
        value: "Crop"
      }]
    }),
    skip_btn: e.formatMessage({
      id: "/4tOwT",
      defaultMessage: [{
        type: 0,
        value: "Skip"
      }]
    }),
    reset_btn: e.formatMessage({
      id: "jm/spn",
      defaultMessage: [{
        type: 0,
        value: "Reset"
      }]
    }),
    close_prompt: e.formatMessage({
      id: "akf4Dz",
      defaultMessage: [{
        type: 0,
        value: "Closing will cancel all uploads, Are you sure?"
      }]
    }),
    image_error: e.formatMessage({
      id: "AeLn0q",
      defaultMessage: [{
        type: 0,
        value: "Error loading image"
      }]
    }),
    corner_tooltip: e.formatMessage({
      id: "hi+DfN",
      defaultMessage: [{
        type: 0,
        value: "Drag corner to resize"
      }]
    }),
    handle_tooltip: e.formatMessage({
      id: "wW7xBB",
      defaultMessage: [{
        type: 0,
        value: "Drag handle to resize"
      }]
    })
  }
});
var o = /* @__PURE__ */ ((e) => (e[e.Avatar = 0] = "Avatar", e[e.InvitePublicImage = 1] = "InvitePublicImage", e[e.HeroBanner = 2] = "HeroBanner", e[e.GalleryImage = 3] = "GalleryImage", e))(o || {});
const _ = (e, t) => {
  const l = b(e);
  return {
    uploadPreset: "e6m9x7iz",
    cloudName: "peerspace-inc",
    showPoweredBy: !1,
    multiple: !1,
    sources: ["local"],
    styles: {
      palette: {
        window: f.white,
        windowBorder: s[500],
        tabIcon: u[800],
        menuIcons: s[600],
        textDark: s[900],
        textLight: f.white,
        link: u[600],
        action: u[600],
        inactiveTabIcon: s[600],
        error: "#F44235",
        inProgress: u[800],
        complete: "#20B832",
        sourceBg: s[200]
      }
    },
    inlineContainer: "#cloudinary-widget-container",
    language: t.locale,
    text: {
      [t.locale]: w(t)
    },
    ...l
  };
}, b = (e) => {
  switch (e) {
    case o.Avatar:
      return {
        cropping: !0,
        croppingCoordinatesMode: "custom",
        croppingAspectRatio: 1.0000001,
        clientAllowedFormats: ["jpg", "jpeg", "png"],
        maxFileSize: 8e6,
        maxImageWidth: 1e3,
        maxImageHeight: 1e3,
        showSkipCropButton: !1
      };
    case o.InvitePublicImage:
      return {
        cropping: !0,
        croppingCoordinatesMode: "custom",
        croppingAspectRatio: 2 / 1,
        clientAllowedFormats: ["jpg", "jpeg", "png", "heic"],
        maxFileSize: 1e7,
        sources: ["local", "url", "camera", "image_search", "google_drive", "dropbox", "shutterstock", "getty", "istock", "unsplash"],
        showSkipCropButton: !1
      };
    case o.HeroBanner:
      return {
        cropping: !0,
        croppingCoordinatesMode: "custom",
        croppingAspectRatio: 4 / 1,
        showSkipCropButton: !1,
        clientAllowedFormats: ["jpg", "jpeg", "png", "heic"],
        maxFileSize: 1e7
      };
    case o.GalleryImage:
      return {
        clientAllowedFormats: ["jpg", "jpeg", "png", "heic"],
        maxFileSize: 1e7
      };
    default:
      return {};
  }
}, A = ({
  onError: e,
  onSuccess: t,
  widgetContainerRef: l,
  uploaderType: n,
  intl: c
}) => {
  const [r, M] = p(), [v, y] = p();
  return m(() => {
    const a = document.createElement("script");
    a.src = "https://upload-widget.cloudinary.com/global/all.js", a.async = !0, a.onload = () => {
      M(window.cloudinary);
    }, document.body.appendChild(a);
  }, []), m(() => {
    if (r && l) {
      const a = _(n, c), i = r.createUploadWidget(a, (d, g) => {
        if (d) {
          e?.(d);
          return;
        }
        if (g.event === "success") {
          const h = g.info;
          t?.(h);
        }
      });
      y(i), i?.open();
    }
  }, [r, l]), {
    cloudinary: r,
    uploadWidget: v
  };
};
export {
  o as C,
  b as a,
  w as b,
  _ as g,
  A as u
};
//# sourceMappingURL=useCloudinaryUploadWidget.BIXIyVyy.js.map
